import React, { useCallback } from "react";

import { Button } from "components";

import styles from "./underwritingNavInfo.module.scss";

type JarisItemProps = {
	jarisApplicationId: string | number;
	status: string;
};

const REACT_APP_JARIS_APP_URL = process.env.REACT_APP_JARIS_APP_URL;

const JarisItem = ({ jarisApplicationId, status }: JarisItemProps) => {
	const onClickHandler = useCallback(() => {
		if (REACT_APP_JARIS_APP_URL) {
			// Validate jarisApplicationId is a valid number/string
			const sanitizedId = encodeURIComponent(String(jarisApplicationId));
			window.open(
				`${REACT_APP_JARIS_APP_URL}/partner/underwriting/applications/${sanitizedId}`,
				"_blank",
				"noopener,noreferrer",
			);
		}
	}, [jarisApplicationId]);

	return (
		<div className={styles.assigneeHolder}>
			<div>{status}</div>
			<Button
				className={styles.assigneeButton}
				minWidth="auto"
				variant="secondary"
				value="View"
				disabled={!REACT_APP_JARIS_APP_URL}
				onClick={onClickHandler}
			/>
		</div>
	);
};

export default JarisItem;
